/**
 * PremiumPackageInfoRemapper
 *
 * Maps PremiumPackageInfoDto (data layer) → PremiumPackageInfoEntity (domain).
 * Flutter source: lib/data/models/premium_package_info.dart
 */
import type { PremiumPackageInfoDto } from '@/data/dtos/info/premiumPackageInfoDto';
import type { JsonObject } from '@/data/types/json';
import type { PremiumPackageInfoEntity } from '@/domain/entities/info/premiumPackageInfoEntity';

export class PremiumPackageInfoRemapper {
  static fromDto(dto: PremiumPackageInfoDto): PremiumPackageInfoEntity {
    return { ...dto };
  }

  static fromJson(data: JsonObject): PremiumPackageInfoDto {
    return {
      coins: (data['coins'] as number | undefined) ?? 0,
      packageName: (data['packageName'] as string | undefined) ?? '',
    };
  }

  static fromJsonList(dataList: JsonObject[]): PremiumPackageInfoDto[] {
    return dataList.map(PremiumPackageInfoRemapper.fromJson);
  }
}
